import React from 'react';
import { layout } from '../../theme/tokens';
import { useIsMobile } from '../../hooks/useMediaQuery';

const Container = ({ style, children, as: Tag = 'div', ...rest }) => {
  const isMobile = useIsMobile();
  return (
    <Tag
      style={{
        width: '100%', maxWidth: layout.containerMax, margin: '0 auto', boxSizing: 'border-box',
        padding: '0 ' + (isMobile ? layout.gutterMobile : layout.gutter) + 'px', ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Container;
